export default function isUnavailable(obj) {
  return !obj || Object.keys(obj).length === 0;
}
